import { combineReducers } from 'redux';
import {webSettingReducer} from "./webSettingReducer";
const rootReducer = combineReducers({
    webSetting: webSettingReducer
    // Add other reducers here
});

export default rootReducer;
